import { render, staticRenderFns } from "./ProcessesTableSection.vue?vue&type=template&id=e3a23848&scoped=true"
import script from "./ProcessesTableSection.ts?vue&type=script&lang=ts&external"
export * from "./ProcessesTableSection.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessesTableSection.vue?vue&type=style&index=0&id=e3a23848&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a23848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3a23848')) {
      api.createRecord('e3a23848', component.options)
    } else {
      api.reload('e3a23848', component.options)
    }
    module.hot.accept("./ProcessesTableSection.vue?vue&type=template&id=e3a23848&scoped=true", function () {
      api.rerender('e3a23848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Dashboard/components/ProcessesTableSection/ProcessesTableSection.vue"
export default component.exports